import { Injectable } from '@angular/core';
import { Http,Response, Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs";
import {Gasto} from "../gasto/gasto";
import {AuthenticationService} from "../Login/authentication.service";
import {UrlService} from "./url.service";


@Injectable()
export class GastoService
{

  private headers = new Headers({'Content-Type':'application/json',
    'Authorization': 'Bearer ' + this.authenticationService.token });//parametrizamos a json
  private options = new RequestOptions({ headers: this.headers });
  private url = this.URL.getLocal()+'/gasto';//Url que maeja GET ,POST
  private urlById = '';//busca un Gasto por cedula
  private urlFilesById = this.URL.getLocal()+'/gasto/archivo/';//busca los archivos de un Gasto por id
  private urlDeleteFile = this.URL.getLocal()+'/gasto/archivo/eliminar/';//la direccion para borrar archivos
  private urlPut = this.URL.getLocal()+'/gasto/';//la direccion a la cual se conecta


  //Constructor de la clase
  constructor(private URL:UrlService,private http:Http, private authenticationService: AuthenticationService)
  {
    //this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //this.headers.append('X-Requested-With', 'XMLHttpRequest');
  }
  //Obtiene una lista de Gastos
  getGasto():Observable<Gasto[]> {
    let url = `${this.url}`;
    return this.http.get(url,this.options)
      .map(r => r.json())
      .catch(this.handleError)
  }

  addGasto(Gasto:Gasto) {
    let url = `${this.url}`;
    let iJson = JSON.stringify(Gasto);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  putGasto(Gasto : Gasto,id:number){
    let url = `${this.urlPut}${id}`;
    let CJson = JSON.stringify(Gasto);
    return this.http.put(url,CJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }
//Este metodo detecta un error en la llamada a http
  private handleError(error : Response | any) {
    let errMsj : string;
    if(error instanceof Response)
    {
      let body  = error.json() || '';
      let err = body.error || JSON.stringify(body);
      errMsj = `${error.status} - ${error.statusText || ''} ${err}`;
    }
    else
    {
      errMsj = error.message ? error.message : error.Tostring();
    }
    return Observable.throw(errMsj);
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/gasto.service.ts